import React, {useEffect} from 'react';
import {
    Col,
    Row
} from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import ProgramList from "./_list";
import ProgramForm from "./_form";

import {showLoader} from "../../../components/loader/loader";
import {
    clearState,
    setApp,
    setCategory,
    setLoading,
    setUdn,
    setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {connect} from "react-redux";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import ProgramDetail from "../programDetail/ProgramDetail";

const Program = (props) => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const newItem = () => {
        props.setForm(false, false, false);
        props.setViewMode('FORM');
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            viewMode === "LIST" ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonNew onClick={newItem}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    {(
                        function() {
                            switch (viewMode) {
                                case "FORM" :
                                    return <ProgramForm />
                                case "DETAILS" :
                                    return <ProgramDetail />
                                default:
                                    return <ProgramList />
                            }
                        })()}
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setApp,
    setCategory,
    setForm,
    setViewMode,
    setLoading,
});

export default connect(mapStateToProps, mapActionsToProps)(Program)
